'use client';

import Link from 'next/link';
import nothingIcon from '../../../../assets/images/icons/icon-wchance-nothing.png';
import FaIcon, { faClock } from '../../../../components/icon/FaIcon/FaIcon';
import { ImageView, WChanceStaging } from '../../../../components/ui';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { newDate } from '../../../../utils/date';
import { isVersion } from '../../../../utils/version';
import type { WChanceDrawResultGoodsItem } from '../../types';
import styles from './WChanceResultSingle.module.scss';
export type WChanceResultSingleProps = {
  wChanceResults: WChanceDrawResultGoodsItem[];
  version?: string | null;
};

function WChanceResultSingle({ wChanceResults, version }: WChanceResultSingleProps) {
  const wChanceResult = wChanceResults[0];
  const isNothing = (item: WChanceDrawResultGoodsItem) => {
    return !item.goodsId;
  };

  // 日時フォーマット関数（date.tsを修正せずに済むよう、ここで定義）
  const formatDateTime = (dateStr: string) => {
    const date = newDate(dateStr);
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
  };

  return (
    <>
      {isNothing(wChanceResult) ? (
        <div className={styles.nothingComponentStyle}>
          <div className={styles.nothingImageWrapper}>
            <ImageView src={nothingIcon.src} alt='' />
          </div>
          <p className={styles.nothingText}>残念、ハズレ..</p>
        </div>
      ) : (
        <div className={styles.componentStyle}>
          <Link
            className={styles.itemLink}
            href={(() => {
              return isVersion(version, '2.0') && wChanceResult.cutoffId
                ? `/account/collection/${wChanceResult.goodsId}?cutoffId=${wChanceResult.cutoffId}`
                : `/account/collection/${wChanceResult.goodsId}`;
            })()}
          >
            <div className={styles.imageWrapper}>
              <div className={styles.itemImage}>
                <ImageView src={wChanceResult.imageUrl} />
                {/* 演出 */}
                <div className={styles.rankWrapper}>
                  <WChanceStaging size={'xLarge'} />
                </div>
              </div>
            </div>
            <div className={`${styles.itemName} ${utilsStyles.textBold}`}>{wChanceResult.goodsName}</div>
            {wChanceResult.startAt && wChanceResult.endAt && (
              <div className={styles.dateInfo}>
                <FaIcon icon={faClock} size={'lg'} />
                &nbsp;
                {formatDateTime(wChanceResult.startAt)} 〜 {formatDateTime(wChanceResult.endAt)}
              </div>
            )}
          </Link>
        </div>
      )}
    </>
  );
}

export default WChanceResultSingle;
